import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import API from "../../../Network/API";
import { useNavigate } from "react-router-dom";
import { ADD_MY_COURSE_SUCCESS } from "../../../Reducer/myCourseSlice";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

export default function AddCourse() {
    const [show, setShow] = useState(false);
    const [course_type, setCourseType] = useState(1);
    const categories = useSelector((state) => state.categoryReducer);
    const [step, setStepMode] = useState(0);
    const [loading, setLoad] = useState(false);
    const [file, setFile] = useState(null);
    const [video_file, setVideoFile] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [photoURL, setPhotoURL] = useState(null);
    const [videoURL, setVideoURL] = useState(null);
    const editorRef = useRef(null);
    const editorRef1 = useRef(null);
    const [order_setting, setOrderSetting] = useState();
    const [total_fee, setTotalFee] = useState(0);
    const [total_price, setTotalPrice] = useState(0);

    const [selectedFile, setSelectedFiles] = useState(null);
    const [cropper, setCropper] = useState(null);
    const [uploadStatus, setUploadStatus] = useState("");

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => setSelectedFiles(reader.result);
            reader.readAsDataURL(file);
        }
    }


    const handleShow = () => {
        setShow(!show)
    };


    useEffect(() => {
        API.get(`/v1/oauth/order_setting`).then((response) => {
            setOrderSetting(response.data.data)
        }).catch((error) => {
        });

    }, []);

    const setStep = (sl) => {
        if (step + sl == 2) {
            const editorData = editorRef.current?.editor?.getData();
            const title = document.querySelector('input[name="title"]').value;
            const category = document.querySelector('select[name="category"]').value;
            if (title.trim() === "") {
                toast.error('Course name is required');
                return;
            }
            if (category === "") {
                toast.error('Category is required');
                return;
            }
            if (editorData === "") {
                toast.error('Description is required');
                return;
            }
        } else if (step + sl == 3) {
            if (!selectedFile) {
                toast.error('Thumbnail is required');
                return;
            }
            if (!video_file) {
                toast.error('Intro video is required');
                return;
            }
        }
        setStepMode(step + sl);
    }

    useEffect(() => {


    }, [step]);


    const calculateTotalPrice = (price) => {
        const p = Number(price) || 0;
        const feePct = Number(order_setting?.order_fee) || 0;
        setTotalPrice(p - (p * feePct) / 100);
        setTotalFee((p * feePct) / 100);
    }

    const courseType = (type) => {
        setCourseType(type)
    }

    const setSelectedFile = (e) => {
        setFile(e.target.files[0])
        setPhotoURL(URL.createObjectURL(e.target.files[0]))
    };

    const onchangeCover = (e) => {
        if (e.target.files[0]) {
            if (e.target.files[0].size > 50 * 1024 * 1024) {
                toast.error('Intro video must be 50MB or smaller');
                e.target.value = '';
                return;
            }
            setVideoFile(e.target.files[0])
            setVideoURL(URL.createObjectURL(e.target.files[0]))
        }
        // console.log(e.target.files[0]);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoad(true);
        const editorData = editorRef.current?.editor?.getData();
        const editorData1 = editorRef1.current?.editor?.getData();
        if (event.target.title.value == "") {
            toast.error('Course name was required')
            setLoad(false);
            setStepMode(1)
            return false;
        }

        if (event.target.category.value == "") {
            toast.error('Category name was required')
            setLoad(false);
            setStepMode(1)
            return false;
        }

        if (editorData == "") {
            toast.error('Course description was required')
            setLoad(false);
            setStepMode(1)
            return false;
        }

        if (!video_file) {
            toast.error('Intro video is required')
            setLoad(false);
            setStepMode(2)
            return false;
        }

        const fd = new FormData();
        fd.append('title', event.target.title.value)
        fd.append('description', editorData)
        fd.append('requirements', editorData1)
        fd.append('category', event.target.category.value)
        fd.append('price', event.target.price.value)
        fd.append('gender_id', event.target.gender.value)
        fd.append('course_type', course_type)

        if (cropper) {
            const croppedBlob = await new Promise((resolve) => {
                cropper.getCroppedCanvas().toBlob((blob) => {
                    resolve(blob);
                }, "image/jpeg");
            });

            if (croppedBlob) {
                fd.append('image', croppedBlob, 'thumbnail.jpg');
            }
        }

        // if (file) {
        //     fd.append('image', file, file?.name)
        // }

        if (video_file) {
            fd.append('video_attach', video_file, video_file?.name)
        }

        API.post("/v1/oauth/teacher/course/save", fd, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
                console.log("Progress: " + progressEvent.loaded / progressEvent.total);
            }
        }).then((response) => {
            setLoad(false)
            document.getElementById("msform").reset()
            toast.success(response.data.message);
            dispatch(ADD_MY_COURSE_SUCCESS(response.data.data))
            navigate('/dashboard/my-courses')

        }).catch((err) => {
            toast.error(err?.response?.data?.message || 'Could not create the course. Please try again.');
            setLoad(false)
        });
    }

    return (
        <>
            <div className="tutor-sign-in-section newCourseUpload">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <form id="msform" onSubmit={handleSubmit}>

                                <ul id="progressbar" className="newCourseUploadprogressbar">
                                    <li className={`${step == 0 ? 'active' : ''}`} id="type">Course Type</li>
                                    <li className={`${step == 1 ? 'active' : ''}`} id="info">Basic Info</li>
                                    <li className={`${step == 2 ? 'active' : ''}`} id="media">Media</li>
                                    {course_type == 1 ?
                                        <li className={`${step == 3 ? 'active' : ''}`} id="prices">Price</li>
                                        : ''}

                                </ul>

                                <div className="row justify-content-center">
                                    <div className="col-md-12">
                                        <fieldset className={`text-end ${step == 0 ? 'active show' : 'hide'}`} >
                                            <div className="form-card card mb-4">
                                                <div className="card-body">
                                                    <div className="step-heading newCourseUploadStepHeading">
                                                        <h2>First, let's find out what type of course you're making.</h2>
                                                    </div>
                                                    <div className="select-course-type">
                                                        <div className="row">
                                                            <div className="col-xl-4 col-lg-4 col-md-4">
                                                                <div className={`categoryCard ${course_type == 1 ? 'active' : ''}`} onClick={() => courseType(1)}>
                                                                    <div className="categoryCard__icon">
                                                                        <i className="fa-light fa-clapperboard-play" />
                                                                    </div>
                                                                    <div className="categoryCard__content">
                                                                        <h4 className="categoryCard__title">Course</h4>
                                                                        <div className="categoryCard__text">Create rich learning experiences with the help of video lectures, quizzes, coding exercises, etc.</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-4 col-lg-4 col-md-4">
                                                                <div className={`categoryCard ${course_type == 2 ? 'active' : ''}`} onClick={() => courseType(2)}>
                                                                    <div className="categoryCard__icon">
                                                                        <i className="fa-light fa-users-class" />
                                                                    </div>
                                                                    <div className="categoryCard__content">
                                                                        <h4 className="categoryCard__title">Group Class</h4>
                                                                        <div className="categoryCard__text">Create rich learning experiences with the help of video lectures, quizzes, coding exercises, etc.</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-4 col-lg-4 col-md-4">
                                                                <div className={`categoryCard ${course_type == 3 ? 'active' : ''}`} onClick={() => courseType(3)}>
                                                                    <div className="categoryCard__icon">
                                                                        <i className="fa-sharp fa-light fa-list-check" />
                                                                    </div>
                                                                    <div className="categoryCard__content">
                                                                        <h4 className="categoryCard__title">Live Class</h4>
                                                                        <div className="categoryCard__text ">Help students prepare for certification exams by providing practice questions.</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <button onClick={() => setStep(1)} type="button" className="next action-button input-hight-44 btn btn-login box-shadow-1 fw-bold">Next</button>
                                        </fieldset>
                                        <fieldset className={`text-end ${step == 1 ? 'active show' : 'hide'}`}>
                                            <div className="form-card card mb-4">
                                                <div className="card-body">
                                                    <div className="step-heading newCourseUploadStepHeading">
                                                        <h2>Basic Information</h2>
                                                    </div>
                                                    <div className="step-form">
                                                        <div className="form-group mb-3 row">
                                                            <div className="col-12">
                                                                <label htmlFor="Title" className="form-label ">Title <span className="ms-1 text-danger">*</span></label>
                                                                <input name="title" type="text" className="form-control rounded input-hight-44" id="Title" placeholder="Enter your course title" maxLength={120} />
                                                            </div>
                                                        </div>
                                                        <div className="form-group mb-3 row">
                                                            <div className="col-6">
                                                                <label className="form-label "> Category <span className="ms-1 text-danger">*</span> </label>
                                                                <select required name="category" className="form-select input-hight-44" aria-label="Default select">
                                                                    <option value={``}>Choose...</option>
                                                                    {categories?.data?.length > 0 && categories?.data?.map((item, i) => (

                                                                        <option value={item.id}>{item.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                        </div>

                                                        <div className="form-group mb-3 row">
                                                            <div className="col-6">
                                                                <label className="form-label ">For Gender <span className="ms-1 text-danger">*</span> </label>
                                                                <select name="gender" required className="form-select input-hight-44" aria-label="Default select">
                                                                    <option value={3}>Both</option>
                                                                    <option value={1}>Male</option>
                                                                    <option value={2}>Female</option>

                                                                </select>
                                                            </div>

                                                        </div>


                                                        <div className="form-group mb-3 row">
                                                            <div className="col-12">
                                                                <label className="form-label "> Description <span className="ms-1 text-danger">*</span></label>
                                                                <CKEditor name="description"
                                                                    editor={ClassicEditor}
                                                                    data={``}
                                                                    onReady={(editor) => {
                                                                        editorRef.current = { editor }; // Store the editor instance in ref
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group mb-3 row">
                                                            <div className="col-12">
                                                                <label className="form-label "> Requirements <span className="ms-1 text-danger">*</span></label>
                                                                <CKEditor name="requirements"
                                                                    editor={ClassicEditor}
                                                                    data={``}
                                                                    onReady={(editor) => {
                                                                        editorRef1.current = { editor }; // Store the editor instance in ref
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <button onClick={() => setStep(-1)} type="button" className="next action-button input-hight-44 btn btn-secondary box-shadow-1 fw-bold me-1">Back</button>
                                            <button onClick={() => setStep(1)} type="button" className="next action-button input-hight-44 btn btn-login box-shadow-1 fw-bold">Next</button>
                                        </fieldset>
                                        <fieldset className={`text-end ${step == 2 ? 'active show' : 'hide'}`}>
                                            <div className="form-card card mb-4">
                                                <div className="card-body">
                                                    <div className="step-heading newCourseUploadStepHeading">
                                                        <h2>Upload Media</h2>
                                                    </div>
                                                    <div className="step-form">
                                                        <div className="form-group mb-3 row">

                                                            <div className="col-md-6">
                                                                <div className="featured-title">
                                                                    Featured Image <span>✨</span>
                                                                </div>
                                                                <div className="upload-container">
                                                                    <div className="icon">
                                                                        <i className="bi bi-image"></i>
                                                                    </div>
                                                                
                                                                    <label for="fileInput" className="btn btn-primary btn-sm">Upload Thumbnail</label>
                                                                    <input onChange={handleFileChange} id="fileInput" type="file" className="hidden-file-input" accept="image/jpeg, image/png, image/gif, image/webp"/>
                                                                        <p className="text-muted">JPEG, PNG, GIF, and WebP formats, up to 50MB</p>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="featured-title">
                                                                    Intro Video <span className="ms-1 text-danger">*</span>
                                                                </div>
                                                                <div className="upload-container">
                                                                <label for="fileInputVideo" className="btn btn-primary btn-sm">Upload Video</label>
                                                                    <input id="fileInputVideo" className="hidden-file-input" type="file" onChange={(e) => onchangeCover(e)} accept="video/*" />
                                                                    {/* <p><a href="#" class="text-primary text-decoration-none">Add from URL</a></p> */}
                                                                    <p className="text-muted">MP4, and WebM formats, up to 50MB</p>
                                                                </div>
                                                            </div>



                                                            <div className="col-6">
                                                                {/* <label className="form-label ">Course Thumbnail <span className="ms-1 text-danger">*</span></label>
                                                                <input
                                                                    className="form-control"
                                                                    type="file"
                                                                    onChange={handleFileChange}
                                                                    accept="image/jpeg, image/png"
                                                                /> */}


                                                                {selectedFile && (
                                                                    <Cropper
                                                                        className="mt-3"
                                                                        style={{ height: 300, width: "100%" }}
                                                                        aspectRatio={16 / 9}
                                                                        src={selectedFile}
                                                                        viewMode={1}
                                                                        guides={true}
                                                                        background={false}
                                                                        onInitialized={(instance) => setCropper(instance)}
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="col-6">
                                                                {video_file && (
                                                                    <video width="100%" height="auto" controls className="mt-3"  style={{ height: 300, width: "auto" }}>
                                                                        <source src={videoURL} type={video_file.type} />
                                                                        Your browser does not support the video tag.
                                                                    </video>
                                                                )}
                                                            </div>
                                                            <div className="col-6 d-none">
                                                                <div style={{ backgroundImage: `url(${photoURL})` }} className="photos-upload-inner newCourseUploadStepPhotos position-relative" id="cvpotos1">
                                                                    <input className="photos-upload-input" type="file" onChange={(e) => setSelectedFile(e)} accept="image/jpeg, image/png" />
                                                                    <div className="photos-upload-text">
                                                                        <p className="m-0">Course thumbnail</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 mt-3 d-none">
                                                                <label className="form-label ">Course Sort Video <span className="ms-1 text-danger">*</span></label>
                                                                <input className="form-control" type="file" onChange={(e) => onchangeCover(e)} accept="video/*" />
                                                                {/* <div style={{ backgroundImage: `url(${videoURL})` }} className="photos-upload-inner newCourseUploadStepPhotos position-relative" id="cvpotos2">
                                                                    <input className="photos-upload-input" type="file" onChange={(e) => onchangeCover(e)} />
                                                                    <div className="photos-upload-text">
                                                                        <p className="m-0">Course Sort Video</p>
                                                                    </div>
                                                                </div> */}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <button onClick={() => setStep(- 1)} type="button" className="next action-button input-hight-44 btn btn-secondary box-shadow-1 fw-bold me-2">Back</button>
                                            {course_type == 1 ?
                                                <button onClick={() => setStep(1)} type="button" className="next action-button input-hight-44 btn btn-login box-shadow-1 fw-bold">Next</button>
                                                :
                                                <button type="submit" className="next action-button input-hight-44 btn btn-login box-shadow-1 fw-bold">Finish{loading ? (
                                                    <span
                                                        className="spinner-border spinner-border-sm ml-5"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                ) : (
                                                    <span></span>
                                                )}</button>

                                            }
                                        </fieldset>
                                        <fieldset className={`text-end ${step == 3 && course_type == 1 ? 'active show' : 'hide'}`}>
                                            <div className="form-card card mb-4">
                                                <div className="card-body">
                                                    <div className="step-heading newCourseUploadStepHeading">
                                                        <h2>Course Price</h2>
                                                    </div>
                                                    <div className="step-form">
                                                        <div className="form-group mb-3 row">
                                                            <div className="col-6">
                                                                <label htmlFor="Price" className="form-label ">Regular Price(USD)<span className="ms-1 text-danger">*</span></label>
                                                                <input name="price" onChange={(e) => calculateTotalPrice(e.target.value)} defaultValue={0} type="number" min={0} step="any" className="form-control rounded input-hight-44" id="Price" placeholder="Regular Price" />
                                                            </div>

                                                        </div>
                                                        <div className="form-group mb-3 row">
                                                            <div className="col-6">
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <h5 className="card-title">Price Summary</h5>

                                                                        <div className="d-flex justify-content-between">
                                                                            <p className="card-text">Author fee</p>
                                                                            <p className="card-text">${total_fee}</p>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between">
                                                                            <p className="card-text">You'll earn</p>
                                                                            <p className="card-text">${total_price}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <button onClick={() => setStep(- 1)} type="button" className="next action-button input-hight-44 btn btn-secondary box-shadow-1 fw-bold me-2">Back</button>
                                            <button type="submit" className="next action-button input-hight-44 btn btn-login box-shadow-1 fw-bold">Finish{loading ? (
                                                <span
                                                    className="spinner-border spinner-border-sm ml-5"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                            ) : (
                                                <span></span>
                                            )}</button>
                                        </fieldset>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div >
                </div >
            </div >
        </>
    )
}